/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

interface ICustomStateParam extends ng.ui.IStateParamsService {
    sales_person: string;
    hrm_email: string;
}

class RegisterController {
    public static $inject = [
        '$http',
        '$state',
        '$stateParams',
        'toaster',
        '$uibModal',
        'Login',
        'bsLoadingOverlayService',
        'User',
        'Api',
    ];

    public currentStep = 1;
    public agree = false;
    public agreePP = false;
    public employee;
    public employee_first_name;
    public employee_last_name;
    public employee_email;
    public employee_contact;
    public num_emp;
    public industry;
    public org;
    public org_name;
    public option_1;
    public option_2;
    public option_3;
    public option_4;
    public option_5;
    public option_6;
    public option_7;
    public option_fa1;
    public option_q1;
    private httpService: angular.IHttpService;
    public industry_options = ['accounting', 'advertising', 'aerospace and defense', 'agriculture', 'arts', 'automotive', 'banking', 'biotechnology', 'business services', 'chemical', 'construction', 'consumer goods', 'consumer services', 'customer service', 'e-commerce', 'education', 'electronics', 'energy', 'entertainment', 'environmental products', 'financial services', 'food', 'forestry', 'healthcare', 'hospitality', 'human resources', 'industrial goods and services', 'information services', 'information technology', 'international business and trade', 'investing', 'logistics', 'management', 'marketing', 'materials', 'mining and drilling', 'pharmaceuticals', 'printing', 'publishing', 'real estate', 'retail trade', 'small business', 'telecommunications', 'textiles', 'training', 'transportation', 'wholesale trade', 'other'];
    public num_emp_options = ['1-10', '11-20', '21-50', '51-100', '101-500', '500+'];
    public registration_result = false;

    public org_website;

    public reg_data = {
        org_website: '',
        org_name: '',
        org_industry: '',
        org_num_emp: '',
        hubspot_signup: false,
    };

    public hrm_data = {
        hrm_first_name: '',
        hrm_last_name: '',
        hrm_email:  '',
        hrm_contact_num: ''
    };

    public hrm_email;
    public sales_person: string;
    public customer_email: string;

    constructor(private $http: angular.IHttpService,
                private $state: ng.ui.IStateService,
                private $stateParams: ICustomStateParam,
                private toaster: any,
                private $uibModal: any,
                private Login: ILoginService,
                private bsLoadingOverlayService: IBsLoadingService,
                private User: IUserService,
                private Api: any) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.bsLoadingOverlayService = bsLoadingOverlayService;
        
        this.httpService = $http;
        this.sales_person = $stateParams.sales_person;
        if ($stateParams.hrm_email && $stateParams.hrm_email.indexOf('@') >= 0) {
            this.hrm_email = $stateParams.hrm_email;
            this.doit();
        }
    }

    public validationError(field: any): boolean {
        this.toaster.pop('warning', 'All fields must be filled in. Field ' + field + ' is empty.');
        return false;
    }

    public cancel(form: angular.IFormController): void {
        this.Login.logout().$promise.then(() => {
            // cleaning user-id attr
            angular.element('body').removeAttr('user-id');
            this.User.clearUser();
            this.$state.go('login');
            this.toaster.pop('warning', 'Registration cancelled');
        });
    }

    public gotoLogin(form: angular.IFormController): void {
        this.Login.logout().$promise.then(() => {
            // cleaning user-id attr
            angular.element('body').removeAttr('user-id');
            this.User.clearUser();
            this.$state.go('login');
        });
    }

    public isStepCompleted(step: any): boolean {
        return step <= this.currentStep;
    }

    public gotoStep(step: any): void {
        if (this.org.extra.setup_wizard.max_step) {
            if (step <= this.org.extra.setup_wizard.max_step) {
                this.currentStep = step;
            }
        } else {
            if (step < this.currentStep) {
                this.org.extra.setup_wizard.max_step = this.currentStep;
                this.currentStep = step;
            }
        }
    }

    public validateBusiness(): boolean {
        if (!this.reg_data.org_website) { return this.validationError('Website'); }
        if (!this.reg_data.org_name) { return this.validationError('Business Name'); }
        if (!this.reg_data.org_num_emp) { return this.validationError('Number of employees'); }
        if (!this.reg_data.org_industry) { return this.validationError('Industry'); }
        return true;
    }

    public validateHrm(): boolean {
        this.hrm_data.hrm_email = this.hrm_email;
        if (!this.hrm_data.hrm_first_name) { return this.validationError('First Name'); }
        if (!this.hrm_data.hrm_last_name) { return this.validationError('Last Name'); }
        
        if (!this.hrm_email) { return this.validationError('Work Email'); }
        if (this.hrm_email.indexOf('@') === -1) {
            return this.toaster.pop('warning', 'The email you have entered is not a valid email address');
        }   
        if ( 
            this.hrm_email.toLowerCase().lastIndexOf('@gmail.com') >= 0 ||
            this.hrm_email.toLowerCase().lastIndexOf('@yahoo.com') >= 0 ||
            this.hrm_email.toLowerCase().lastIndexOf('@yahoo.co.uk') >= 0 ||
            this.hrm_email.toLowerCase().lastIndexOf('@hotmail.com') >= 0 ||
            this.hrm_email.toLowerCase().lastIndexOf('@me.com') >= 0 ||
            this.hrm_email.toLowerCase().lastIndexOf('@icloud.com') >= 0 ||
            this.hrm_email.toLowerCase().lastIndexOf('@outlook.com') >= 0 ||
            this.hrm_email.toLowerCase().lastIndexOf('@mail.com') >= 0 ||
            this.hrm_email.toLowerCase().lastIndexOf('@yahoo.ae') >= 0
        ) {
            return this.toaster.pop('warning', 'Please provide a work email. Personal email accounts are not accepted.');
        }
        if (!this.hrm_data.hrm_contact_num) { return this.validationError('Contact Number'); }
        return true;
    }

    public validateStep1(){
        this.hrm_data.hrm_email = this.hrm_email;

        if (!this.hrm_email) return this.validationError('Work Email');
        if (this.hrm_email.indexOf('@') == -1) {
            return this.toaster.pop('warning', 'The email you have entered is not a valid email address');
        }

        if (
            this.hrm_email.toLowerCase().lastIndexOf('@gmail.com') >= 0 ||
            this.hrm_email.toLowerCase().lastIndexOf('@yahoo.com') >= 0  ||
            this.hrm_email.toLowerCase().lastIndexOf('@yahoo.co.uk') >= 0  ||
            this.hrm_email.toLowerCase().lastIndexOf('@hotmail.com') >= 0  ||
            this.hrm_email.toLowerCase().lastIndexOf('@me.com') >= 0  ||
            this.hrm_email.toLowerCase().lastIndexOf('@icloud.com') >= 0  ||
            this.hrm_email.toLowerCase().lastIndexOf('@outlook.com') >= 0  ||
            this.hrm_email.toLowerCase().lastIndexOf('@mail.com') >= 0  ||
            this.hrm_email.toLowerCase().lastIndexOf('@yahoo.ae') >= 0
        ) {
            return this.toaster.pop('warning', 'Please provide a work email. Personal email accounts are not accepted.');
        }

        return true;
    }

    public doit(): any {

        this.hrm_data.hrm_email = this.hrm_email;
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        switch (this.currentStep) {
            case 1: {
                // Check that data is filled in
                if (!this.validateStep1()) {
                    this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                    return;
                }
                
                var request_data_reg: any = {
                    'hrm_email': this.hrm_data.hrm_email,
                    'sales_person': this.sales_person
                };
                this.bsLoadingOverlayService.start({referenceId: 'loader'});
                this.httpService.post('/api/org_create_s1', request_data_reg).then((response) => {
                    this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                    if (response.data && response.data['enriched']) {
                        let e_data = response.data['data'];

                        this.hrm_data.hrm_first_name = e_data.first_name;
                        this.hrm_data.hrm_last_name = e_data.last_name;
                        this.hrm_data.hrm_contact_num = e_data.contact_number;
                        this.reg_data.org_name = e_data.company_name;
                        this.reg_data.org_website = e_data.website;
                    }

                    this.currentStep++;
                }, (response) => {
                    this.toaster.pop('error', response.data.error);
                    this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                    return false;
                });
                break;
            }
            case 2: {
                if (!this.validateHrm()) {
                    this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                    return;
                }
                var request_data_hrm: any = {
                    'org_name': this.reg_data.org_name,
                    'org_industry': this.reg_data.org_industry,
                    'org_number_employees': this.reg_data.org_num_emp,
                    'org_website': this.reg_data.org_website,
                    'hrm_first_name': this.hrm_data.hrm_first_name,
                    'hrm_last_name': this.hrm_data.hrm_last_name,
                    'hrm_email': this.hrm_data.hrm_email,
                    'hrm_contact_num': this.hrm_data.hrm_contact_num,
                    'sales_person': this.sales_person,
                    'hubspot_signup': this.reg_data.hubspot_signup,
                };          

                this.httpService.post('/api/org_create', request_data_hrm).then((response) => {
                    this.registration_result = true;
                    this.currentStep++;
                    this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                }, (response) => {
                    this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                    this.toaster.pop('error', response.data.error);
                    return false;
                });
                break;
            }
            default: {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                return;
            }
                
        }
    }

    public goBack(): void {
        if (this.currentStep > 1) {
            this.currentStep--;
        }
    }

    public isNumberKey(evt: any): void {
        var key: any = evt.keyCode;
        key = String.fromCharCode(key);
        var regex: any = /[0-9]|\./;
        // prevent special characters as well as underscores
        if (((evt.keyCode >= 49 && evt.keyCode <= 56) || evt.keyCode === 189) && (evt.shiftKey === true)) {
            evt.returnValue = false;
            evt.preventDefault();
        }
        if (
                // allow only numbers
            evt.keyCode === 8 || evt.keyCode === 46 || evt.keyCode === 37 || evt.keyCode === 39 ||
                // allow spaces and dashes
            evt.keyCode === 32 || evt.keyCode === 189 ||
                // allow plus sign
            (evt.keyCode === 187 && evt.shiftKey === true) ||
                // allow number pad keys
            evt.keyCode >= 96 && evt.keyCode <= 105 || evt.keyCode === 107 ||
                // enable copy and pasting inside the number fields
            ((evt.keyCode === 65 || evt.keyCode === 86 || evt.keyCode === 67) && (evt.ctrlKey === true || evt.metaKey === true))) {
                evt.returnValue = true;
        } else {
            if (!regex.test(key)) {
                evt.returnValue = false;
                if (evt.preventDefault) {
                    // prevent any other input
                    evt.preventDefault();
                }
            }
        }
    }
}

angular.module('beneple.global')
    .controller('RegisterController', RegisterController);



// WEBPACK FOOTER //
// ./frontend/scripts/global/controllers/register.controller.ts